import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { FaPhone, FaChevronDown, FaWhatsapp } from 'react-icons/fa';

import Link from '../../Link/Link';

import './TopFooter.scss';
import Phone from '../../Icons/Phone';
import MetodiPagamento from '../../Icons/MetodiPagamento';
import Spedizionieri from '../../Icons/Spedizionieri_2';
import A from '../../Anchor/Anchor';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

const TopFooter = ({
  isMobile,
  isCheckout,
  datiFarmacia,
  logoImage,
  siteName,
  discounted,
  pages,
  hasFidelityCard,
  footerTextField,
}) => {
  const menu = [
    {
      id: 1,
      title: siteName,
      content: [
        {
          id: 1.1,
          link: '/registrazione',
          title: 'Registrati gratuitamente',
          show: true,
        },
        {
          id: 1.2,
          link: '/pagine/contattaci',
          title: 'Contattaci',
          show: true,
        },
      ],
    },
    {
      id: 2,
      title: 'Informazioni',
      content: [
        {
          id: 2.1,
          link: '/pagine/condizioni-vendita',
          title: 'Condizioni di vendita',
          show: true,
        },
        {
          id: 2.2,
          link: '/pagine/modalita-costi-spedizione',
          title: 'Modalità e costi spedizione',
          show: true,
        },
        {
          id: 2.3,
          link: '/pagine/resi-e-rimborsi',
          title: 'Resi e rimborsi',
          show: true,
        },
        {
          id: 2.4,
          link: '/pagine/pagamenti-accettati',
          title: 'Pagamenti accettati',
          show: true,
        },
      ],
    },
    {
      id: 3,
      title: 'Garanzie',
      content: [
        {
          id: 3.1,
          link: '/pagine/informativa-privacy',
          title: 'Privacy policy',
          show: true,
        },
        {
          id: 3.2,
          link: '/pagine/informativa-cookie',
          title: 'Cookie policy',
          show: true,
        },
        {
          id: 3.4,
          link:
            'https://www.mimit.gov.it/images/stories/documenti/Legal_guarantee_notice_ITN.pdf',
          title: 'Garanzia legale',
          show: true,
          external: true,
        },
        {
          id: 3.3,
          link: '/pagine/chi-siamo',
          title: 'Chi siamo',
          show:
            !!pages &&
            !!pages.length &&
            !!pages.find(page => page.slug === 'chi-siamo') &&
            !!pages.find(page => page.slug === 'chi-siamo').content,
        },
      ],
    },
    {
      id: 4,
      title: 'Promozioni',
      content: [
        {
          id: 4.1,
          link: '/prodotti-in-offerta',
          title: 'Tutte le offerte',
          show: !!discounted.length,
        },
        {
          id: 4.2,
          link: '/carta-fedelta',
          title: 'Carta Fedeltà',
          show:
            hasFidelityCard &&
            !!pages &&
            !!pages.length &&
            !!pages.find(page => page.slug === 'carta-fedelta') &&
            !!pages.find(page => page.slug === 'carta-fedelta').content,
        },
      ],
    },
  ];

  const renderLink = item =>
    item.external ? (
      <A href={item.link} target="_blank" rel="noopener noreferrer">
        {item.title}
      </A>
    ) : (
      <Link to={item.link}>{item.title}</Link>
    );

  return (
    <div className="top-footer">
      <div className="container">
        {footerTextField && (
          <div className="footer-text-field">
            <p>{footerTextField}</p>
          </div>
        )}
        {/* DESKTOP */}
        {!isMobile && (
          <div className="desktop-footer-menu">
            <div className="address-menu">
              <div className="col-address">
                <ImageDispatcher
                  src={logoImage}
                  alt={siteName}
                  className="logo"
                />
                <address>
                  {datiFarmacia.address1}
                  {datiFarmacia.address2 && ' ' + datiFarmacia.address2}
                  {datiFarmacia.zipcode && ' - ' + datiFarmacia.zipcode}
                  {datiFarmacia.city && ' ' + datiFarmacia.city}
                  {datiFarmacia.province && ' (' + datiFarmacia.province + ')'}
                  {!!datiFarmacia.phone && (
                    <a
                      href={`tel:${datiFarmacia.phone}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        fontSize: 12,
                      }}
                    >
                      <FaPhone />
                      {datiFarmacia.phone}
                    </a>
                  )}
                  {!!datiFarmacia.phone2 && (
                    <a
                      href={`https://wa.me/${datiFarmacia.phone2}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        fontSize: 12,
                      }}
                    >
                      <FaWhatsapp />
                      {datiFarmacia.phone2}
                    </a>
                  )}
                  <br />
                  <div>P. IVA {datiFarmacia.vatCode}</div>
                </address>
              </div>

              {!!menu &&
                menu
                  .filter(col => !col.content.every(c => !c.show))
                  .map(col => {
                    return (
                      <div className="col-menu" key={col.id}>
                        {!isCheckout && (
                          <React.Fragment>
                            <h4 style={{ wordBreak: 'break-all' }}>
                              {col.title}
                            </h4>
                            <ul>
                              {col.content
                                .filter(item => !!item.show)
                                .map(item => {
                                  return (
                                    <li key={item.id}>{renderLink(item)}</li>
                                  );
                                })}
                            </ul>
                          </React.Fragment>
                        )}
                      </div>
                    );
                  })}

              <div className="col-phone">
                {!!datiFarmacia.phone && (
                  <a
                    href={'tel:' + datiFarmacia.phone}
                    style={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: 22,
                    }}
                  >
                    <FaPhone />
                    {datiFarmacia.phone}
                  </a>
                )}
                {!!datiFarmacia.phone2 && (
                  <a
                    href={'https://wa.me/' + datiFarmacia.phone2}
                    style={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: 22,
                    }}
                  >
                    <FaWhatsapp />
                    {datiFarmacia.phone2}
                  </a>
                )}
              </div>
            </div>
          </div>
        )}

        {/* MOBILE */}
        {!!isMobile && (
          <div className="mobile-footer-menu">
            <div className="address-menu">
              <div className="col-address">
                <ImageDispatcher
                  src={logoImage}
                  alt={siteName}
                  className="logo"
                />
                <address>
                  {datiFarmacia.address1}
                  {datiFarmacia.address2 && ' ' + datiFarmacia.address2}
                  {datiFarmacia.zipcode && ' - ' + datiFarmacia.zipcode}
                  {datiFarmacia.city && ' ' + datiFarmacia.city}
                  {datiFarmacia.province && ' (' + datiFarmacia.province + ')'}
                  <br />
                  <div>P. IVA {datiFarmacia.vatCode}</div>
                </address>
              </div>
              <div className="col-phone">
                {!!datiFarmacia.phone && (
                  <div
                    style={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: 22,
                    }}
                  >
                    <FaPhone />
                    <a
                      href={'tel:' + datiFarmacia.phone}
                      style={{ color: 'white' }}
                    >
                      {datiFarmacia.phone}
                    </a>
                  </div>
                )}
                {!!datiFarmacia.phone2 && (
                  <div
                    style={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: 22,
                    }}
                  >
                    <FaWhatsapp />
                    <a
                      href={`https://wa.me/${datiFarmacia.phone2}`}
                      style={{ color: 'white' }}
                    >
                      {datiFarmacia.phone2}
                    </a>
                  </div>
                )}
              </div>
            </div>
            {!!menu && !isCheckout && (
              <Accordion allowZeroExpanded allowMultipleExpanded>
                {menu
                  .filter(col => !col.content.every(c => !c.show))
                  .map(col => {
                    return (
                      <AccordionItem key={col.id}>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            <div
                              style={{
                                marginBottom: 0,
                                color: '#fff',
                                fontSize: 11,
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                              }}
                            >
                              {col.title} <FaChevronDown />
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul>
                            {col.content
                              .filter(item => !!item.show)
                              .map(item => {
                                return (
                                  <li key={item.id}>{renderLink(item)}</li>
                                );
                              })}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    );
                  })}
              </Accordion>
            )}
          </div>
        )}

        <div
          className="info"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div className="info">
            <div className="pagamenti">
              <h4>Pagamenti sicuri</h4>
              <MetodiPagamento />
            </div>
            <div className="spedizioni">
              <h4>Spedizioni rapide</h4>
              <Spedizionieri />
            </div>
          </div>
          <div className={'info'}>
            {[
              datiFarmacia.linkDrugsAuthorizedSite,
              datiFarmacia.showLinkDrugsAuthorizedSiteFooter,
            ].every(r => !!r) && (
              <div className="authorized-site">
                <A
                  className="store-authorized-link"
                  href={datiFarmacia.linkDrugsAuthorizedSite}
                  target="_blank"
                  aria-label="Guarda la nostra autorizzazione ministeriale per la vendita di farmaci"
                >
                  <ImageDispatcher
                    className="lazyload"
                    alt="Logo autorizzazione ministeriale farmaci"
                    src="/static/images/logo_farmacia_autorizzata.png"
                  />
                </A>
              </div>
            )}
            {[
              datiFarmacia.linkDrugsAuthorizedSiteVet,
              datiFarmacia.showLinkDrugsAuthorizedSiteVetFooter,
            ].every(r => !!r) && (
              <div className="authorized-site">
                <A
                  className="store-authorized-link"
                  href={datiFarmacia.linkDrugsAuthorizedSiteVet}
                  target="_blank"
                  aria-label="Guarda la nostra autorizzazione ministeriale per la vendita di farmaci veterinari"
                >
                  <ImageDispatcher
                    className="lazyload"
                    alt="Logo autorizzazione ministeriale veterinari"
                    src="/static/images/logo_farmacia_autorizzata_vet.png"
                  />
                </A>
              </div>
            )}
            {!!datiFarmacia.accessibilityLink && (
              <div className="authorized-site">
                <A
                  className="store-authorized-link"
                  href={datiFarmacia.accessibilityLink}
                  target="_blank"
                  aria-label="Guarda la nostra dichiarazione di accessibilità"
                  style={{ background: 'white' }}
                >
                  <ImageDispatcher
                    className="lazyload"
                    alt="Logo dichirazaione di accessibilità"
                    src="/static/images/logo_farmacia_accessibile.png"
                  />
                </A>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopFooter;
